import { Component } from "react";
import noDataPlaceholder from "../assets/img/nodata_available.svg";

export default class NoDataAvailable extends Component {
  state = {
    hasError: false,
  };

  handleError = () => {
    this.setState({ hasError: true });
  };

  render() {
    const { hasError } = this.state;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "65vh",
          width: "100%",
          backgroundColor: "#fafafa",
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          boxSizing: "border-box",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        {!hasError ? (
          <img
            src={noDataPlaceholder}
            alt="No Data Available"
            onError={this.handleError}
            style={{
              width: "100%",
              maxWidth: "300px",
              height: "auto",
              objectFit: "contain",
              marginBottom: "1rem",
            }}
          />
        ) : (
          <span
            style={{
              color: "#999",
              fontSize: "1rem",
            }}
          >
            No Image Available
          </span>
        )}
      </div>
    );
  }
}
